import { useProduct } from '@/screens/Product/hooks/useProduct'

import cl from '../../ui/product-main/product-panel/components/product-price-block/product-price-block.module.scss'
import { PricesBlock } from '../../ui/product-main/product-panel/components/product-price-widget/PricesBlock/PricesBlock'

import { DiscountBuyButton } from './discount-buy-button'

export const DiscountProductPricePanel = (): JSX.Element => {
	const { product } = useProduct()
	const currentPrice = product.PRICE?.VALUE
	const oldPrice = product.OLD_PRICE?.VALUE

	return (
		<div className={cl.productPannel}>
			{!!currentPrice && <PricesBlock currentPrice={currentPrice} oldPrice={oldPrice} />}
			<DiscountBuyButton product={product} fullWidth />
		</div>
	)
}
